import React from 'react';
import './MenuDisplay.css';

const MenuDisplay = ({ menus, menusPicker, categories, addToCart }) => {
  return (
    <div>
      <h2>Nos Menus</h2>
      <div className="menu-display-container">
        {menus.map(menu => (
          <div key={menu.id} className="menu-display">
            <button className="add-button add-menu" onClick={() => addToCart(menu)}>+</button>
            <h3>{menu.nom}</h3>
            <p>{menu.prix} €</p>
            <p>{menu.description}</p>
            {menu.options.entrées && (
              <div>
                <h4>Entrées</h4>
                <ul>
                  {menu.options.entrées.map(id => {
                    const item = categories.entrées.find(item => item.id === id);
                    return item ? <li key={id}>{item.nom}</li> : null;
                  })}
                </ul>
              </div>
            )}
            {menu.options.plats && (
              <div>
                <h4>Plats</h4>
                <ul>
                  {menu.options.plats.map(id => {
                    const item = categories.plats.find(item => item.id === id);
                    return item ? <li key={id}>{item.nom}</li> : null;
                  })}
                </ul>
              </div>
            )}
            {menu.options.garnitures && (
              <div>
                <h4>Garnitures</h4>
                <ul>
                  {menu.options.garnitures.map(id => {
                    const item = categories.garniture.find(item => item.id === id);
                    return item ? <li key={id}>{item.nom}</li> : null;
                  })}
                </ul>
              </div>
            )}
            {menu.options.desserts && (
              <div>
                <h4>Desserts</h4>
                <ul>
                  {menu.options.desserts.map(id => {
                    const item = categories.desserts.find(item => item.id === id);
                    return item ? <li key={id}>{item.nom}</li> : null;
                  })}
                </ul>
              </div>
            )}
          </div>
        ))}
        {menusPicker.map(menu => (
          <div key={menu.id} className="menu-display">
            <button className="add-button add-menu" onClick={() => addToCart(menu)}>+</button>
            <h3>{menu.nom}</h3>
            <p>{menu.prix} €</p>
            <p>{menu.description}</p>
            <ul>
              {menu.options.all.map(id => {
                const item = Object.values(categories).flat().find(item => item.id === id);
                return item ? <li key={id}>{item.nom}</li> : null;
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuDisplay;
